<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Бланки строгой отчетности') }}</h1>
    <div class="my-organization">
      <div class="blanks-pg bgw-pdg-20">
        <div class="flex-two-col">
          <div class="flex-two-col__left">
            <Menu/>
          </div>
        </div>
        <div class="flex-two-col">
          <div class="flex-two-col__left">
            <div class="add-npa-row">
              <v-btn class="v-btn btn-add-category" @click="goToCreate()">
                {{ $t('Создать БСО') }}
              </v-btn>
            </div>
          </div>
        </div>
        <div class="table-overflow">
          <table class="table-full">
            <thead>
            <tr>
              <td class="td-num">№</td>
              <td>{{ $t('Тип БСО') }}</td>
              <td class="text-center">{{ $t('Стартовый номер') }} - {{ $t('Конечный номер') }}</td>
              <td class="text-center">{{ $t('Цена бланка') }}</td>
              <td class="text-center">{{ $t('Количество') }}</td>
              <td class="text-center">{{ $t('Дата изготовления') }}</td>
              <td class="text-center">{{ $t('Дата генерации') }}</td>
              <td class="text-center">{{ $t('Действия') }}</td>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in bsos" :key="item.id">
              <td class="td-num">{{ index+1 }}</td>
              <td>{{ item.strictReportingFormType.transCorrectName }}</td>
              <td class="text-center">{{ item.startNumber }} - {{ item.endNumber }}</td>
              <td class="text-center">{{ item.blankPrice }}</td>
              <td class="text-center">{{ item.bsoCount }}</td>
              <td class="text-center">{{ new Date(item.makeDate) | dateFormat('DD.MM.YYYY') }}</td>
              <td class="text-center">{{ new Date(item.createdDate) | dateFormat('DD.MM.YYYY') }}</td>
              <td class="text-center">
                <v-btn class="btn-delete" @click.native.stop="deleteProductionBso(item.id)">
                  <v-icon>delete_forever</v-icon>
                </v-btn>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <v-pagination
          v-model="page"
          :length="paginationData.pageCount"
          total-visible="10"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Menu from '@/components/bso/Menu'
import BSO from '@/model/bso'

export default {
  components: {
    Menu
  },
  data: () => ({
    breadcrumbs: [],
    bsos: [],
    page: 1,
    paginationData: {},
    search: {}
  }),
  mounted () {
    this.fetchData(false)
    this.scrollToTop()
  },
  watch: {
    $route: 'fetchData',
    page () {
      this.fetchData(false)
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    // получаем данные
    fetchData (resetPage = true) {
      this.setLoading(true)
      if (resetPage) {
        this.page = 1
      }
      this.search.page = this.page
      BSO.getProductionBsos(this.search)
        .then((response) => {
          this.bsos = response.data.items
          this.paginationData = response.data.paginationData
          this.generateBreadcrumbs()
          this.setLoading(false)
        })
        .catch((error) => {
          console.log(error)
          this.setLoading(false)
        })
    },
    deleteProductionBso (id) {
      if (confirm(this.$i18n.t('Вы действительно хотите удалить запись о выданных БСО?'))) {
        this.setLoading(true)
        BSO.deleteProductionBso(id)
          .then((response) => {
            if (response.status === 200) {
              this.fetchData(false)
            } else {
              this.setLoading(false)
            }
          })
          .catch((error) => {
            this.setLoading(false)
            this.$noty.error(this.$i18n.t('Удалить данные БСО невозможно, так как в системе есть использованные бланки.'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          })
      }
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Список БСО'),
          disabled: true
        }
      ]
    },
    // Переход на страницу создания
    goToCreate () {
      this.$router.push({
        name: 'bso-create'
      })
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.table-overflow{
  table {
    thead {
      td {
        line-height: 1.4;
        vertical-align: middle;
      }
    }
  }
}
</style>
